import { createDraftSafeSelector } from "@reduxjs/toolkit";
import moment from "moment";
import { budgetChartSummarizedDataSelector } from "@/store/budgets/selectors/current-budget/chart/budgetChartSummarizedDataSelector";
import { currentBudgetSelector } from "@/store/budgets/selectors/current-budget/currentBudgetSelector";
import { getPlannedBudgetsMap } from "@/components/pages/common/billing-explorer/utils/getPlannedBudgetsMap";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const budgetChartSummarizedWithBudgetDataSelector =
  createDraftSafeSelector(
    [
      budgetChartSummarizedDataSelector,
      currentBudgetSelector,
      organisationQuarterStartMonthSelector,
    ],
    (totals, budget, quarterStartMonth) => {
      const { period, start_date, planned_amounts, type, amount } =
        budget?.body ?? {};

      const plannedMap = getPlannedBudgetsMap(
        start_date,
        period,
        planned_amounts,
        quarterStartMonth,
      );

      return totals?.map(({ formatedDate, total, date }) => {
        const { quarter: budgetStartQuarter } = getFQuarterByStartMonth(
          moment(date).month() + 1,
          quarterStartMonth,
        );

        const dateAsNumber =
          period === "monthly" ? moment(date).month() : budgetStartQuarter;

        const budgetAmount =
          (type === "fixed" ? amount : plannedMap?.[dateAsNumber]) ?? 0;

        return {
          date: formatedDate,
          total,
          budget: budgetAmount,
        };
      });
    },
  );
